import { FileText, TrendingUp, CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { DisputeDto } from "@shared/types/DisputeDto";

interface DisputeStatsProps {
  disputes: DisputeDto[];
}

export function DisputeStats({ disputes }: DisputeStatsProps) {
  const totalDisputes = disputes.length;
  const needsAction = disputes.filter(
    (d) => d.status === "OPEN" || d.status === "AWAITING_CLIENT_RESPONSE",
  ).length;
  const resolvedDisputes = disputes.filter(
    (d) => d.status === "RESOLVED" || d.status === "CLOSED",
  ).length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card className="glass-card border-gradient">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">
                Total Disputes
              </p>
              <p className="text-3xl font-bold">{totalDisputes}</p>
            </div>
            <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center">
              <FileText className="h-6 w-6 text-blue-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="glass-card border-gradient border-l-4 border-l-primary">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Needs Action</p>
              <p className="text-3xl font-bold text-primary">{needsAction}</p>
            </div>
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
              <TrendingUp className="h-6 w-6 text-primary" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="glass-card border-gradient border-l-4 border-l-emerald-500">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Resolved</p>
              <p className="text-3xl font-bold text-emerald-400">
                {resolvedDisputes}
              </p>
            </div>
            <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center">
              <CheckCircle2 className="h-6 w-6 text-emerald-400" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
